import React, { useEffect, useState } from "react";
import { config } from "../config/config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import showConfirm from "./ConfirmAlert";

const NotaList = ({ onEdit, reloadTrigger }) => {
    const [notas, setNotas] = useState([]);
    const [alumnos, setAlumnos] = useState({});
    const [materias, setMaterias] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        setLoading(true);
        setError(null);

        Promise.all([
            fetch(`${config.apiUrl}/notas`, { signal }).then(res => res.json()),
            fetch(`${config.apiUrl}/alumnos/asignaciones`, { signal }).then(res => res.json()),
            fetch(`${config.apiUrl}/materias`, { signal }).then(res => res.json())
        ])
            .then(([notasData, alumnosData, materiasData]) => {
                setNotas(notasData);

                const alumnosMap = {};
                alumnosData.forEach(alumno => {
                    alumnosMap[alumno.alumno_id] = alumno.alumno_nombre;
                });
                setAlumnos(alumnosMap);

                const materiasMap = {};
                materiasData.forEach(materia => {
                    materiasMap[materia.materia_id] = materia.nombre_materia;
                });
                setMaterias(materiasMap);
            })
            .catch(err => {
                if (err.name !== "AbortError") {
                    console.error(err);
                    setError("Error al cargar los datos");
                }
            })
            .finally(() => setLoading(false));

        return () => {
            controller.abort();
        };
    }, [reloadTrigger]);

    const handleDelete = async  (notaId) => {
        const isConfirmed = await showConfirm();

        if (isConfirmed) {
            fetch(`${config.apiUrl}/notas/${notaId}`, { method: "DELETE" })
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Error al eliminar la nota");
                    }
                    console.log("Nota eliminada");
                    setNotas(prevNotas => prevNotas.filter(nota => nota.nota_id !== notaId));
                })
                .catch(err => {
                    console.error(err);
                    setError("Error al eliminar la nota");
                });
        }
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Lista de Notas</h2>
            {loading && <p>Cargando...</p>}
            {error && <p style={{ color: "red" }}>{error}</p>}
            <table className="table table-bordered table-striped table-dark">
                <thead className="thead-dark">
                <tr>
                    <th>Alumno</th>
                    <th>Materia</th>
                    <th>Año</th>
                    <th>Período</th>
                    <th>Nota</th>
                    <th colSpan={2} className="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody>
                {notas.length > 0 ? (
                    notas.map((nota) => (
                        <tr key={nota.nota_id}>
                            <td>{alumnos[nota.alumno_id] || "Cargando..."}</td>
                            <td>{materias[nota.materia_id] || "Cargando..."}</td>
                            <td>{nota.ano}</td>
                            <td>{nota.periodo}</td>
                            <td>{nota.nota}</td>
                            <td className="text-center">
                                <button
                                    className="btn btn-warning btn-sm mr-2"
                                    onClick={() => onEdit(nota)}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </button>
                            </td>
                            <td className="text-center">
                                <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => handleDelete(nota.nota_id)}
                                >
                                    <FontAwesomeIcon icon={faTrashAlt} />
                                </button>
                            </td>
                        </tr>
                    ))
                ) : (
                    !loading && (
                        <tr>
                            <td colSpan="7" className="text-center">
                                No hay notas disponibles
                            </td>
                        </tr>
                    )
                )}
                </tbody>
            </table>
        </div>
    );
};

export default NotaList;
